<template>
  <section class="page-container">
    <div class="flex flex-sb-center pd-80">
      <h1>Quote ready to</h1>
      <div class="flex flex-align-center">
        <div class="flex flex-align-center">
          <div class="form-item mg-r-3">
            <span>Source</span>
          </div>
          <el-form
            ref="formSource"
            :rules="rules"
            :model="formData">
            <div class="form-item width-335">
              <el-form-item
                ref="ref_agency_id"
                :rules="rules.select"
                prop="ref_agency_id">
                <v-select
                  v-model="formData.ref_agency_id"
                  :disabled="formData.admin_created_id==0"
                  :list="globalOptions.ref_agency"
                  @change="changeReferrerAgency" />
              </el-form-item>
            </div>
          </el-form>
        </div>
        <span class="mg-l-8">
          <v-button
            gray
            @click="handleBack">Previous</v-button></span>
        <span class="mg-l-8">
          <v-button
            gray
            @click="handleCancel">Cancel</v-button></span>
      </div>
    </div>
    <div class="main-contain">
      <div class="content">
        <el-form
          ref="form"
          :rules="rules"
          :model="formNet">
          <div
            class="select-pay"
            :class="{'checked':selectPay==1}">
            <el-radio
              v-model="selectPay"
              label="1"
            ><span class="select-span">To Referrer</span></el-radio
            >
            <el-collapse-transition>
              <div
                v-show="selectPay == 1"
              >
                <div
                  v-if="selectPay == 1">
                  <span class="fs-14 block fw-400 color-dark mg-t-20">Send quote to referrer: {{referrer.isrd_nm}}</span>
                  <span class="gray-box mg-t-20 block mg-b-20 flex-sb-center">
                    <span class="fs-14 fw-600 color-gray">Total Payable</span>
                    <span  class="fs-14 fw-600 color-dark">{{ amountResult | formatMoney(2, true) }}</span>
                  </span>
                  <v-button
                    green
                    @click="handleSendReferrer"
                  >Pass to referrer</v-button>
                </div>
              </div>
            </el-collapse-transition>
          </div>
          <div
            v-if="!isTBC"
            class="select-pay"
            :class="{'checked':selectPay==2}">
            <el-radio
              v-model="selectPay"
              label="2"
            ><span class="select-span">To Policyholder</span></el-radio
            >
            <el-collapse-transition>
              <div
                v-if="selectPay == 2"
                class="margin-top">
                <div
                  v-if="isCanNet"
                  class="form-item">
                  <span class="label">Total Payable</span>
                  <div class="form-input" >
                    <el-form-item
                      ref="net_payable"
                      :rules="rules.net_payable"
                      prop="net_payable">
                      <v-input
                        v-model.number="formNet.net_payable"
                        money
                        prepend="HKD"
                        @blur="handleSetNet" />
                    </el-form-item>
                  </div>
                </div>
                <v-checkbox
                  v-if="has_old_reward"
                  v-model="reward_type"
                  :no-number="1"
                  :is-boolean="false"
                  :select-number="2"
                  @change="handleSetNet"
                >Old Client Reward</v-checkbox>
                <div class="border-box">
                  <p class="bold-content">Send Payment and Signature Link</p>
                  <v-button
                    green
                    @click="handlerDialog(1)"
                  >Using SMS</v-button>
                  <v-button
                    gray
                    :disabled="!formData.send_email"
                    @click="handlerDialog(3)"
                  >Email</v-button>
                </div>
                <div class="border-box border-none">
                  <p class="bold-content">Pay on behalf and Send Signature Link</p>

                  <v-button
                    gray
                    @click="handlerPay"
                  >
                    <span class="icon"><font-awesome-icon
                      icon="money-bill-wave"></font-awesome-icon></span>
                    <span>Pay on behalf</span></v-button>
                </div>
              </div>
            </el-collapse-transition>
          </div>
          <div
            v-if="productId == 11"
            class="select-pay"
            :class="{'checked':selectPay==3}">
            <el-radio
              v-model="selectPay"
              label="3"
            ><span class="select-span">Application Offline</span></el-radio>
            <el-collapse-transition>
              <div
                v-if="selectPay == 3"
                class="margin-top">
                <div
                  v-if="isCanNet"
                  class="form-item">
                  <span class="label">Payable</span>
                  <div class="form-input" >
                    <el-form-item
                      ref="net_payable"
                      :rules="rules.net_payable"
                      prop="net_payable">
                      <v-input
                        v-model.number="formNet.net_payable"
                        money
                        prepend="HKD"
                        @blur="handleSetNet" />
                    </el-form-item>
                  </div>
                </div>
                <div class="border-box border-none">
                  <p class="bold-content">Send Payment and Signature Link</p>
                  <v-button
                    green
                    @click="handlerDialog(1)"
                  >Using SMS</v-button>
                  <!--                  <v-button-->
                  <!--                    gray-->
                  <!--                    :disabled="!formData.send_email"-->
                  <!--                    @click="handlerDialog(3)"-->
                  <!--                  >Email</v-button>-->
                </div>
              </div>
            </el-collapse-transition>
          </div>
        </el-form>
      </div>
      <div class="margin-top-dollar">
        <div class="flex flex-algin">
          <span
            v-if="!isSME"
            class="icon icon-content">
            <img
              :src="plan_info.company_icon"
              alt="company"/>
          </span>
          <span
            v-else
            class="icon icon-content">
            <img
              :src="getOptionData('companySmallIcon', formData.company_id).logo? getOptionData('companySmallIcon', formData.company_id).logo:''"
            >
          </span>
          <span
            class="icon icon-content"
          >
            <font-awesome-icon
              v-if="formData.class_id"
              :icon="getOptionName('iconOptions', formData.class_id)" />
          </span>
          <span class="label break-work">{{ planName }}</span>
        </div>

        <div class="flex-content">

          <div class="flex-box">
            <div
              v-for="(item, index) in sidebarPremium"
              :key="index"
              class="flex-info">
              <span>{{ item.item }}</span>
              <span>{{ item.premium_str }}</span>
            </div>
            <div
              class="flex-info ">
              <span>Manual Discount</span>
              <span>
                <v-input
                  v-model="spec_disc_prm"
                  prepend="- $"
                  @blur="handlerQuoteDiscount"></v-input>
              </span>
            </div>
            <div
              class="flex-info ">
              <span>Admin Charge</span>
              <span>
                <v-input
                  v-model="handling_fee"
                  prepend="+ $"
                  @blur="handlerQuoteDiscount"></v-input>
              </span>
            </div>
            <div
              class="flex-info total-amount">
              <span>Total Payable</span>
              <span class="amount">{{ amountResult | formatMoney(2, true) }}</span>
            </div>
          </div>
        </div>
        <code-select
          :orderId="orderId"
          :notApply="true"
          :isQuote="false"
          :customerId="formData.customer_id"
          :customer="formData.customer"
          :is-user="true"
          :is-fina="isFina"
        ></code-select>
      </div>
    </div>
    <send-email-sms
      ref="send-email-sms"
      :form="formData"
      is-fina
      :is-only-referrer="isSendReferrer"
      :type="contactType"
      :initContent="formData.url_data"
      :init-refer-content="isSendReferrer&&selectPay!=3?initReferContent:formData.referrer_url_data"
      @send="handlerSend"
      @skip="handlerSkip" />
  </section>
</template>
<script>
import {mapActions, mapState} from 'vuex'
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import SendEmailSms from '@/views/components/dialogs/send-email-sms'
import MixinSendSMSEmail from '@/mixins/sendSMSEmail'
import {
  getQuoteDetail,
  paymentLinkSend
} from '@/api/quote'
import {setQuoteDiscount,setMgmDiscount} from '@/api/order'
import {getNewSMEQuoteDetail} from '@api/new_sme'
import MixinFormat from '@/mixins/format'
import {getSMEQuoteDetail} from '@api/sme'
import CodeSelect from '@/views/components/code-select'
import MixinSource from '@/mixins/source'
export default {
  name: 'ReferrerQuotePayment',
  components:{
    SendEmailSms,
    CodeSelect
  },
  mixins: [MixinOptions, MixinRules,MixinFormat,MixinSendSMSEmail,MixinSource],
  data() {
    const checkNetPayable = (rule, value, cb) => {
      let {max_payable,min_payable} = this.reward_other_data||{}
      if(value==''||value>max_payable||value<min_payable){
        cb(new Error(`輸入範圍${min_payable} ~ ${max_payable}`))
      }
      cb()
    }
    return {
      contactType:0,
      reward_type:1,
      // isSendReferrer:false,
      selectPay:'1',
      isApplication:'0',
      spec_disc_prm:'',
      handling_fee:'',
      type:[],
      formData:{ref_agency_id:''},
      formNet:{net_payable:''},
      premium_info:[],
      rules: {
        net_payable: [
          {validator: checkNetPayable, trigger: ['change', 'blur']}
        ],
      }
    }
  },
  computed: {
    // ...mapState('common', ['productId']),
    has_old_reward(){
      let {reward_other_data} =this.formData||{}
      if(reward_other_data.length<=0)
        return false
      return true
    },
    reward_other_data(){
      let {reward_other_data} =this.formData||{}
      let obj  = {}
      if(reward_other_data.length<=0)
        return this.formData
      reward_other_data.filter((item)=>{
        if(item.reward_type == this.reward_type)
          obj = item
      })
      let {max_payable=0,min_payable=0} = obj||{}

      return {max_payable,min_payable}
    },
    isTBC(){
      let {amount} = this.formData
      return amount == 'TBC'
    },
    isSendReferrer(){
      return [1,3].includes(Number(this.selectPay))
    },
    planName(){
      return this.formData.plan
    },
    referrer(){
      return this.formData.referrer||{}
    },
    isNewSME(){
      let {sme_versions} = this.$route.query||{}
      return sme_versions==3
    },
    amountResult() {
      const { amount } = this.formData
      let pay_amount = amount
      if(this.isSME){
        let total =  this.premium_info.find(item => item.name == 'paid')||{}
        pay_amount = total.premium
      }
      return Number(pay_amount)
    },
    sidebarPremium() {
      let coverageList
      if(this.isSME){
        coverageList =this.premium_info
      }else {
        let {sidebar_premium=[]} = this.formData.quote_coverage_list||{}
        coverageList = sidebar_premium||[]
      }
      if(!coverageList) {
        return []
      }
      let {spec_disc_prm,handling_fee,sidebar_info={}} = this.formData
      this.spec_disc_prm = spec_disc_prm
      this.handling_fee  =handling_fee
      if(this.isSME){
        this.spec_disc_prm = sidebar_info.spec_disc_prm
        this.handling_fee  =sidebar_info.handling_fee
      }
      let premium =coverageList.filter(item => item.name != 'paid'&&item.name!='handling_fee'&&item.name!='spec_disc_prm')
      return  premium
    },
    sidebar_info(){
      let {sidebar_info={}} = this.formData
      return sidebar_info
    },
    plan_info(){
      let {quote_coverage_list} = this.formData||{}
      let {plan_info} =quote_coverage_list||{}
      return plan_info||{}
    },
    extraBenefitSelect(){
      let {extra_benefits=[]} = this.formData
      let extraOption = this.allOptions11.extra_benefits||[]
      let arr = extra_benefits.reduce((result,item)=>{
        extraOption.some(option=>{
          if(option.id == item){
            result.push(option)
          }
        })
        return result
      },[])
      if(this.isFina) return []
      return arr||[]
    },
    orderId() {
      return this.$route.query.order_id
    },
    sme_versions() {
      return this.$route.query.sme_versions||2
    },
    quoteNo() {
      return this.$route.query.quote_no
    },
    isSME() {
      return this.$route.query.product_id>=80
    },
    quoteType() {
      return this.$route.query.type || ''
    },
    customerData(){
      return{
        contact_phone:this.formData.phone,
        contact_email:this.formData.send_email
      }
    },
    isPaidSignature(){
      const {stts,is_signature} = this.formData
      return stts>=401&&(is_signature==1||is_signature==0)||stts==0
    },
    customer_name(){
      return  this.detailData.customer.isrd_nm
    },
    customerName() {
      const {
        cust_typ,
        isrd_lst_nm,
        isrd_fst_nm,
        contact_nm } = this.isPaidSignature
      if(cust_typ == 1) {
        return `${isrd_lst_nm} ${isrd_fst_nm}`
      }

      return contact_nm
    },
    customerPhone() {
      const { cust_typ, mobile_no, contact_phone } = this.isPaidSignature
      if(cust_typ == 1) {
        return mobile_no
      }
      return contact_phone
    },
    isCanNet(){
      let {type} = this.formData||{}
      return [10,20].includes(type)
    },
    isEndorse(){
      let {type} = this.formData||{}
      return [30,40].includes(type)
    },
    isRenew(){
      let {type} = this.formData||{}
      return [20].includes(type)
    },
    isFina(){
      return true
    },
    isReferCase(){
      let {is_refer_order} = this.formData||{}
      return is_refer_order == 1
    },
    productId(){
      let {product_id} = this.$route.query||{}
      return product_id
    }
  },
  watch: {
    amountResult:{
      immediate:true,
      handler(val){
        this.formNet.net_payable = val||0
      }
    }
  },
  created() {
    this.getDetail()
  },
  methods: {
    handleApplication(){
      // this.isApplication = this.isApplication==1?0:1
      if(this.isApplication==1){
        this.isSendReferrer = false
        this.contactType = 1
        this.$refs['send-email-sms'].changeDialog()
      }
    },
    handleBack(){
      this.$router.back()
    },
    handleCancel(){
      let path = this.isSME?'/records/sme/ticket/list':'/records/quote'
      this.$router.push(path)
    },
    getDetail(){
      if(this.isSME){
        this.network().getNewSMEQuoteDetail()
        return
      }
      this.network().getQuoteDetail()
    },
    handlerQuoteDiscount(){
      this.network().setQuoteDiscount()
    },
    handleSetNet(){
      this.$refs.form.validate((valid, rules) => {
        if (valid) {
          this.network().setMgmDiscount()
        }
      })

    },
    handleSendReferrer(){
      this.$refs['send-email-sms'].changeDialog()
    },
    handlerDialog(type){
      this.contactType = type
      this.$refs['send-email-sms'].changeDialog()
      // this.$refs['manual-dialog'].changeDialog()
    },
    saveManual(isSend){
      this.refreshPolicy()
      if(isSend)
        this.$refs['send-email-sms'].changeDialog()
    },
    refreshPolicy(){
      this.getDetail()
    },
    async handlerSendReferrer(params){
      await this.mixinNetwork().sendQuoteReferrer(params)
      this.handleReferPath()
    },
    async handlerSend(content,type,data) {
      let {referrer_send,referrer_content,customer_send} =data
      let params = {
        content,
        referrer_content,
        is_send: 1
      }
      if(!customer_send) delete params.content
      if(!referrer_send) delete params.referrer_content
      if(this.isSendReferrer){
        params ={
          order_id: this.orderId,
          content:referrer_content
        }
        this.handlerSendReferrer(params)
        return
      }
      await this.network().paymentLinkSend(params)
    },
    handleReferPath(){
      if(this.isEndorse){
        let {ticket_id} = this.$route.query
        this.$router.push({
          path: '/tickets/detail',
          query: {
            ticket_id: ticket_id,
            product_id: this.productId,
            sme_versions:this.sme_versions
          }
        })
      }else
        this.$router.push({
          path: '/records/quote/detail',
          query: {
            order_id: this.orderId,
            product_id: this.productId,
            sme_versions:this.sme_versions
          }
        })
    },
    async handlerSkip() {
      if(this.isSendReferrer){
        let params ={
          order_id: this.orderId,
          content:''
        }
        this.handlerSendReferrer(params)
        return
      }
      this.network().paymentLinkSend({
        content: '',
        is_send: 0
      })
    },
    handlerPay(){
      if(this.isPaidSignature) {
        this.$router.push({
          path: '/records/quote/detail',
          query: {
            order_id: this.orderId,
            product_id: this.productId,
            sme_versions:this.sme_versions
          }
        })
      }
      else{
        this.$router.push({
          path: '/quoting/payment',
          query: {
            order_id: this.orderId,
            product_id: this.productId,
            quote_type: this.quoteType == 'renew'? 'renew': '',
            sme_versions:this.sme_versions
          }
        })
      }
    },
    routerToPolicy() {
      this.$router.push({
        path:'/records/quote/detail',
        query: {
          order_id: this.orderId,
          product_id:this.productId,
          sme_versions:this.sme_versions
        }
      })
    },
    network() {
      return {
        getSMEQuoteDetail:async ()=>{
          let {data} = await getSMEQuoteDetail({
            order_id:this.orderId
          },this.productId)
          let {sidebar_info=[]} = data
          this.premium_info = sidebar_info
          this.formData = data
        },
        getNewSMEQuoteDetail:async ()=>{
          let {data} = await getNewSMEQuoteDetail({
            order_id:this.orderId
          },this.productId)
          this.formData = data
          let {sidebar_info=[],reward_type} = data
          this.premium_info = sidebar_info
          this.reward_type  =reward_type||1
        },
        getQuoteDetail: async () => {
          let { data } = await getQuoteDetail({
            order_id: this.orderId
          },this.productId)
          this.formData = data
          let {reward_type=1} = data||{}
          this.reward_type  =reward_type||1
        },
        setQuoteDiscount: async (params) => {
          const {data} = await setQuoteDiscount({
            order_id: this.orderId,
            spec_disc_prm:this.spec_disc_prm,
            handling_fee:this.handling_fee,
          })
          this.getDetail()
        },
        sendQuoteReferrer: async () => {
          const { data } = await sendQuoteReferrer({
            order_id:this.orderId,
          })

        },
        setMgmDiscount: async () => {
          const { data } = await setMgmDiscount({
            order_id:this.orderId,
            ...this.formNet,
            reward_type:this.reward_type
          })
          this.getDetail()
        },
        paymentLinkSend: async (params = {}) => {
          const { data } = await paymentLinkSend({
            ...params,
            order_id: this.orderId,
            send_type: this.contactType == 1? 1: 2,
          })
          this.$message({
            type: 'success',
            message: data.message_language
          })
          this.handleReferPath()
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.page-container {
  h1 {
    padding-bottom: 5px;
  }
  .radio-circle {
    display: inline-block;
    //   box-sizing: border-box;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    border: 1px solid #d5d8de;
    background: white;
    cursor: pointer;
  }
  .radio-circle-checked {
    position: relative;
    display: inline-block;
    //   box-sizing: border-box;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    background: #409eff;
    &::before {
      position: absolute;
      content: "";
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 5px;
      height: 5px;
      border-radius: 100%;
      background: white;
    }
  }
  .flex {
    margin-top: 15px;
    .card {
      margin-right: 15px;
      width: 448px;
    }
    h3 {
      padding-bottom: 10px;
      font-size: 20px;
    }
    .left {
      padding: 15px 10px 15px 15px;
      border-right: 1px solid #dddfe7;

      .mg-t-10 {
        margin-top: 10px;
      }
      .mg-b-10 {
        margin-bottom: 10px;
      }
      .client {
        font-size: 16px;
        font-weight: 500;
        & > span {
          display: inline-block;
          padding-left: 5px;
          font-weight: 400;
        }
      }
    }
    .right {
      padding: 15px 15px 15px 10px;
    }
  }
  .border-box{
    p{
      padding:32px 0 16px 0;
      color: #24292E;
      font-family: Inter;
      font-size: 14px;
      letter-spacing: 0;
    }
    padding-bottom: 32px;
    border-bottom: 1px solid #E1E4E8;
    &.border-none{
      border-bottom: 0;
    }
    //margin-bottom: 31px;

  }
  .bold-content{
    font-weight: bold;
    padding:32px 0 16px 0;
    color: #24292E;
    font-family: Inter;
    font-size: 14px;
    letter-spacing: 0;
  }
  .icon{
    margin-right: 10px;
  }
}
.pd-80{
  padding: 0 88px;
  margin-bottom: 30px;
}
.main-contain {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  padding: 0 88px;
  justify-content: space-between;
  >div{
    //width: 50%;
  }
  .content{
    width: 60%;
  }
  >div:last-child{
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    //padding: 31px 0;
  }
  .send-container {
    margin-right: 15px;
    width: 450px;
  }
  .payment-container {
    width: 450px;
    .verify-container {
      & > span:first-child {
        display: block;
        padding-bottom: 15px;
        font-size: 16px;
        color: #616266;
      }
      .verify-next {
        padding-top: 15px;
        .waiting {
          display: block;
          padding-bottom: 10px;
          color: #616266;
          font-size: 16px;
          span {
            display: inline-block;
            padding-left: 5px;
          }
        }
      }
    }
  }
}
.company-logo {
  margin-top: 31px;
  display: flex;
  width: 280px;
  img {
    // width: 100%;
    //height: 100%;
    margin-right: 26px;
    margin-left: 11px;
    height: 51px;
  }
}
.flex-content {
  width: 280px;
  .flex-box {
    border-radius: 5px;
    border: 1px solid #E1E4E8;
    width: 280px;
    margin: 16px 0;

    .flex-info {
      display: flex;
      justify-content: space-between;
      padding: 23px 15px;
      border-bottom: 1px solid #E1E4E8;

      span:first-child {
        color: #586069;
        font-size: 14px;
        font-weight: 500;
        width: 50%;
      }

      span:last-child {
        color: #24292E;
        font-size: 14px;
      }
      .flex-column{
        p{
          font-size: 14px;
          font-weight: 500;
          height: 24px;
        }
        .item_title{
          color: #586069;
        }
        .name{
          color: #0366D6;
        }
        .flag_tag{
          span{
            color: #C24E00;
            padding: 0px 8px;
            background: #FFFFFF;
            border: 1px solid #F66A0A;
            border-radius: 100px;
            height: 22px;
            display: inline-block;
            width: auto;
          }
        }
      }
    }

    .total-amount {
      background: #f6f8fa;
      border-bottom: 0;
    }
    .transa-color{
      span{
        color: rgb(205,43,56)!important;
      }

    }

    .amount {
      color: #24292E;
      font-weight: bolder;
    }
  }
}


.right {
  margin-left: 15px;
  min-width: 200px;
  max-width: 200px;

  .label {
    display: block;
    margin: 10px 0;
    font-size: 16px;
    line-height: 19px;
    font-weight: bold;
  }
  .total-box {
    margin: 15px -15px -15px -15px;
    padding: 15px;
    background: #ECF5FF;
    span {
      display: block;
      color: #616266;
      font-size: 14px;
    }
    .amount {
      font-size: 24px;
      color: #409eff;
      font-weight: bold;
    }
  }
}
.flex-algin{
  //align-items: center;
  margin-bottom: 10px;
  width: 280px;
  .label{
    margin-top: 0;
    word-break: break-word;
  }
  .icon{
    margin-right: 15px;
    height: 22px;
    width: 22px;
    color: #6A737D;
    border-radius: 5px;
    text-align: center;
    img{
      height: 22px;
      width: 22px;
    }
  }
  .icon-content{
    height: 22px;
    width: 22px;
    border-radius: 5px;
    background-color: #E1E4E8;
    color: #6A737D;
    font-size: 14px;
    text-align: center;
    line-height: 22px;
  }
}
.select-pay {
  border: 1px solid #d1d5da;
  border-radius: 5px;
  background-color: #fff;
  padding: 20px;
  margin-bottom: 20px;
  &.checked{
    border-color: #409EFF;
  }
  .select-span {
    color: #24292e;
    font-family: Inter;
    font-size: 14px;
    font-weight: 600;
  }
  .margin-top {
    margin-top: 20px;
  }
  .form-half {
    width: calc(100% - 170px);
  }
}
.gray-box{
  background:#F6F8FA;
  height: 64px;
  padding: 0 15px;
  display: block;
  width: 100%;
  display: flex;
  align-items: center;

}
</style>

